import { handleInvalidValue } from '../../../../shared/error/handleInvalidValue';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';
import { CreditCardType } from '../../../domain/models';

export function useTranslationForType(type: CreditCardType) {
	const { t } = useTranslation();

	switch (type) {
		case CreditCardType.AmericanExpress:
			return t('payment_card_type_amex');

		case CreditCardType.Mastercard:
			return t('payment_card_type_mastercard');

		case CreditCardType.Visa:
			return t('payment_card_type_visa');

		case CreditCardType.Discover:
			return t('payment_card_type_discover');

		default:
			handleInvalidValue(type);
			return type;
	}
}
